import React, { forwardRef } from 'react';

import logoConlicitacaoColorido from 'assets/images/logo-conlicitacao-colorido.svg';

export { biddingSummaryPrintPageStyles } from './styles';

export interface BiddingSummaryPrintRootProps {
  biddingId: number;
  numeroLicitacao?: string | null;
  children: React.ReactNode;
}

export const BiddingSummaryPrintRoot = forwardRef<HTMLDivElement, BiddingSummaryPrintRootProps>(
  ({ biddingId, numeroLicitacao, children }, ref) => {
    const trimmedNumero = numeroLicitacao?.trim();
    const issuedAt = new Date();
    const issuedDate = issuedAt.toLocaleDateString('pt-BR');
    const issuedTime = issuedAt.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return (
      <div className="p-3 pb-0 bidding-summary-print-root" ref={ref}>
        <div className="d-none summary-print-cover">
          <img
            src={logoConlicitacaoColorido}
            alt="Conlicitação"
            className="summary-print-cover-logo"
          />
          <div className="summary-print-cover-text">
            <div className="summary-print-cover-title">
              {trimmedNumero ? `Resumo do Edital ${trimmedNumero}` : 'Resumo do Edital'}
            </div>
            <div className="summary-print-cover-meta">Nº Conlicitação: {biddingId}</div>
            <div className="summary-print-cover-date">
              Emitido em {issuedDate} às {issuedTime}
            </div>
          </div>
        </div>
        {children}
      </div>
    );
  },
);

BiddingSummaryPrintRoot.displayName = 'BiddingSummaryPrintRoot';
